import requests from '../requests'

export default {
  list () {
    return requests.get('meta/project-types')
  }
}
